import { localytics, analytics } from "@hcecbp/webappanalytics";

const defaultTagEventDelay = 2000;

export const TAG_EVENT_CONST = {
  comment: 'comment',
  share: 'share',
  review: 'review',
  role: 'role'
};

export const CUSTOM_DIMENSIONS_INDEX = {
    org: 0,
    env: 1,
    userId: 2,
    role: 3
}

export function tagScreen(screenName:string):void{
    setTimeout(() => 
        (screenName) && localytics.tagScreen(screenName),
        defaultTagEventDelay
    );
}

export function tagEvent(eventName:string, data:any):void{
    setTimeout(() => 
        (eventName) && (data) && localytics.tagEvent(eventName, data),
        defaultTagEventDelay
    );
}

export function tagNavigation(screenName:string):void {
    tagEvent('navigate', {Feature: screenName,});
}

export function setUser(userId:string):void {
    localytics.setGlobalAttribute({UserId: userId});
    localytics.setCustomDimension(CUSTOM_DIMENSIONS_INDEX.userId, userId);
}

export function setEnv(env:string):void {
    localytics.setGlobalAttribute({Env: env});
    localytics.setCustomDimension(CUSTOM_DIMENSIONS_INDEX.env, env);
}

export function setOrganization(org:string):void {
    localytics.setGlobalAttribute({Org: org});
    localytics.setCustomDimension(CUSTOM_DIMENSIONS_INDEX.org, org);
}

export function setUserRole(role:string):void{
    localytics.setGlobalAttribute({Role: role});
    localytics.setCustomDimension(CUSTOM_DIMENSIONS_INDEX.role, role);
}